export default "__VITE_ASSET__DNr$b1sR__"